// Last line of defence for render crashes: shows a way out instead of a blank page,
// and reports the crash (web/lib/report.ts).
import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportError } from "../lib/report";
import { buttonClass } from "./ui";

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    reportError("react", error, { componentStack: info.componentStack?.split("\n").slice(0, 8).join("\n").slice(0, 300) ?? null });
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="mx-auto max-w-md space-y-4 p-8 text-center">
        <h1 className="text-xl font-semibold tracking-tight">Something went wrong</h1>
        <p className="text-sm text-muted">The page hit an error. Your saved contracts are safe on this device. Reloading usually fixes it.</p>
        <button type="button" className={buttonClass()} onClick={() => location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
